export default '/static/frontend/ReachDigital/12gobiking/dist/assets/dpd-ec3c8776.svg'